export default "__VITE_ASSET__D50hqN1y__"